// Indices de l'enum SignUpResultError renvoyée par l'API : toute insertion côté back décale ces valeurs.
export enum LoginError {
  PasswordIsNull = 0,
  LoginIsNull = 1,
  InvalidCredentials = 2,
  AccountIsLocked = 3,
  InvalidPassword = 4,
  NoUsableRight = 5
}
